import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from '@mui/material'

interface NotesModalProps {
    open: boolean
    onClose: () => void
    notes: string | null
    candidateName: string
}

export default function NotesModal({ open, onClose, notes, candidateName }: NotesModalProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Notes for {candidateName}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ minHeight: '200px' }}>
                    {notes ? (
                        <Typography
                            variant="body1"
                            sx={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                lineHeight: 1.6
                            }}
                        >
                            {notes}
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No notes available for this candidate.
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

